var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 81,
    rx: 40.5,
    fill: "#F7F7F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2121_3366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4935 33.1195C48.2373 33.332 48.1623 33.5758 48.2498 33.882C48.2935 34.032 49.1123 34.8945 51.356 37.1508L54.406 40.2195L39.9373 40.2508C28.781 40.2758 25.4373 40.3008 25.3373 40.357C25.0185 40.5383 24.8873 41.1258 25.0998 41.4258C25.3435 41.7758 24.3185 41.7508 40.0123 41.7508H54.4685L51.3685 44.857C49.3935 46.8383 48.2498 48.0258 48.2248 48.132C48.1748 48.357 48.2873 48.707 48.4623 48.8695C48.656 49.057 49.0498 49.107 49.2873 48.982C49.3873 48.9258 51.1623 47.1883 53.2373 45.1133L56.9998 41.3445V41.0008V40.657L53.1623 36.8195L49.3248 32.982L49.0248 32.957C48.756 32.932 48.6935 32.9508 48.4935 33.1195Z",
    fill: "#182948"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2121_3366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.ec7f50ab68e22b24a0ea493e67392be7.svg";
export { ForwardRef as ReactComponent };